import Konva from 'konva'

/**
 * KONVA
 */
export default {
    data() {
        return {
            // canvas宽度
            canWidth: 0,
            // 页面canvas
            pageStage: null,
            // canvas的图层列表
            pageLayer: [],
            isvertical: false,
            ishorizontal: false,
            horizontaguideLine: "",
            verticalguideLine: "",

        }
    },
    created() {
    },
    methods: {
        getTimestamp(prefix = '') {
            const timestamp = new Date().getTime().toString()
            if (prefix) {
              return prefix + timestamp
            } else {
              return timestamp
            }
          },
        /**
         * 生命周期--初始化
         */

        thinit2(width,height,widtho,heighto) {
            if (this.$refs.thcontainer) {
                const main = this.$refs.thcontainer
                this.$refs.thcontainer.style.position = 'relative';
                this.canWidth = main.offsetWidth
                this.pageStage = new Konva.Stage({
                    container: 'container',
                    width: width,
                    height: height,
                })
                this.addLayer(width,height,widtho,heighto)
            }
        },

        
        /**
         * 按钮--新增图层
         */
        addLayer(width,height,widtho,heighto) {
            const fillLayer = new Konva.Layer()
            this.pageStage.add(fillLayer)
            this.pageLayer.push({ fillLayer })
            const bglayer = new Konva.Layer()
            this.pageStage.add(bglayer)
            this.pageLayer.push({ bglayer })
            const name = this.getTimestamp('l_')
            const layer = new Konva.Layer()
            this.pageLayer.push({ name, layer })
            this.pageStage.add(layer)


            const transformer = new Konva.Layer()
            this.pageStage.add(transformer)
            this.pageLayer.push({ transformer })


            const gridLayer = new Konva.Layer()
            this.pageStage.add(gridLayer)
            this.pageLayer.push({ gridLayer })
            this.addRuler(width,height,widtho,heighto,gridLayer)

        },
        addRuler(width,height,widtho,heighto,gridLayer, n=0) {
            var that = this;
            this.pageStage.find(".gridLh").forEach((line) => {
                if (line.attrs.ismove == undefined) {
                    line.destroy();
                }
            });
            this.pageStage.find(".gridLv").forEach((line) => {
                if (line.attrs.ismove == undefined) {
                    line.destroy();
                }
            });
            if (this.$refs.thcontainer) {
                var stageWidth = width;
                var stageHeight = height;
                var padding = 0; // 标尺与画布边缘的距离
                var scaleLength = 5; // 刻度线长度
                var scaleInterval = 100; // 刻度线间隔

                var numDivisions = 5;
                for (var y = padding; y <= stageHeight - padding; y += scaleInterval) {
                    var scaleLine = new Konva.Line({
                        points: [padding, y, padding + scaleLength, y],
                        stroke: 'black',
                        strokeWidth: 1,
                        name: "gridLv",
                        reference: false,
                    });

                    gridLayer.add(scaleLine);
                    var divisionInterval = scaleInterval / (numDivisions + 1);
                    for (var i = 1; i <= numDivisions; i++) {
                        var divisionLine = new Konva.Line({
                            points: [padding, y + i * divisionInterval, padding + 3, y + i * divisionInterval],
                            stroke: 'black',
                            strokeWidth: 1,
                            name: 'gridLv',
                            reference: false,
                        });

                        gridLayer.add(divisionLine);
                    }

                    var text = new Konva.Text({
                        x: padding + scaleLength + 5,
                        y: y - 5,
                        text: ((y / width) * widtho).toFixed(n),
                        fontSize: 10,
                        fill: 'black',
                        name: "gridLv",
                        reference: false,
                    });
                    text.on('mouseover', function () {
                        document.body.style.cursor = 'col-resize';
                    });
                    text.on('mouseout', function () {
                        document.body.style.cursor = 'default';
                    });
                    scaleLine.on('mousedown', function () {
                        var xPos = this.points()[0];
                        drawGuideLine(xPos, 'vertical');
                        that.isvertical = true;
                    });
                    text.on('mousedown', function () {
                        var xPos = this.x();
                        drawGuideLine(xPos, 'vertical');
                        that.isvertical = true;
                    });

                    gridLayer.add(text);
                }

                for (var x = padding; x <= stageWidth - padding; x += scaleInterval) {
                    var scaleLine = new Konva.Line({
                        points: [x, padding, x, padding + scaleLength],
                        stroke: 'black',
                        strokeWidth: 1,
                        name: "gridLh",
                        reference: false,
                    });

                    gridLayer.add(scaleLine);
                    var divisionInterval = scaleInterval / (numDivisions + 1);
                    for (var i = 1; i <= numDivisions; i++) {
                        var divisionLine = new Konva.Line({
                            points: [x + i * divisionInterval, padding, x + i * divisionInterval, padding + 3],
                            stroke: 'black',
                            strokeWidth: 1,
                            name: 'gridLh',
                            reference: false,
                        });

                        gridLayer.add(divisionLine);
                    }

                    var text = new Konva.Text({
                        x: x - 5,
                        y: padding + scaleLength + 5,
                        text: ((x / height) * heighto).toFixed(n),
                        fontSize: 10,
                        fill: 'black',
                        name: "gridLh",
                        reference: false,
                    });
                    text.on('mouseover', function () {
                        document.body.style.cursor = 'row-resize';
                    });
                    text.on('mouseout', function () {
                        document.body.style.cursor = 'default';
                    });

                    scaleLine.on('mousedown', function () {
                        var yPos = this.points()[1];
                        drawGuideLine(yPos, 'horizontal');
                        that.ishorizontal = true;
                    });
                    text.on('mousedown', function () {
                        var yPos = this.y();
                        drawGuideLine(yPos, 'horizontal');
                        that.ishorizontal = true;
                    });

                    gridLayer.add(text);
                }

                function drawGuideLine(a, orientation) {

                    if (orientation === 'horizontal') {
                        that.horizontaguideLine = new Konva.Line({
                            points: [0, a, width, a],
                            stroke: '#4affff',
                            strokeWidth: 2.9,
                            name: "gridLh",
                            reference: true,
                            Linefollow: false,
                            ismove: false,
                        });
                        that.horizontaguideLine.on('mouseover', function () {
                            document.body.style.cursor = 'row-resize';
                        });
                        that.horizontaguideLine.on('mouseout', function () {
                            document.body.style.cursor = 'default';
                        });
                        that.horizontaguideLine.on('mousedown', function () {
                            that.horizontaguideLine = this;
                            that.ishorizontal = true;
                        });
                        that.horizontaguideLine.on('dblclick', function () {
                            this.destroy();
                            document.body.style.cursor = 'default';
                        });
                        gridLayer.add(that.horizontaguideLine);
                        gridLayer.draw();
                    } else if (orientation === 'vertical') {
                        that.verticalguideLine = new Konva.Line({
                            points: [a, 0, a, height],
                            stroke: '#4affff',
                            strokeWidth: 2.9,
                            name: "gridLv",
                            reference: true,
                            Linefollow: false,
                            ismove: false,
                        });
                        that.verticalguideLine.on('mouseover', function () {
                            document.body.style.cursor = 'col-resize';
                        });
                        that.verticalguideLine.on('mouseout', function () {
                            document.body.style.cursor = 'default';
                        });
                        that.verticalguideLine.on('mousedown', function () {
                            that.verticalguideLine = this;
                            that.isvertical = true;
                        });
                        that.verticalguideLine.on('dblclick', function () {
                            this.destroy();
                            document.body.style.cursor = 'default';
                        });
                        gridLayer.add(that.verticalguideLine);
                        gridLayer.draw();
                    }

                }
                // 渲染绘制的内容
                gridLayer.draw();
                this.pageStage.on('mousemove', function (e) {

                    var endX = e.evt.offsetX;
                    var endY = e.evt.offsetY;

                    if (that.ishorizontal && that.horizontaguideLine) {
                        that.horizontaguideLine.attrs.ismove = true;
                        that.horizontaguideLine.points([0, endY, width, endY]);
                    } else if (that.isvertical && that.verticalguideLine) {
                        that.verticalguideLine.attrs.ismove = true;
                        that.verticalguideLine.points([endX, 0, endX, height]);
                    }

                    gridLayer.batchDraw();
                });

                this.pageStage.on('mouseup', function () {
                    if (that.ishorizontal && that.horizontaguideLine) {
                        if (!that.horizontaguideLine.attrs.ismove) {
                            that.horizontaguideLine.attrs.Linefollow = !that.horizontaguideLine.attrs.Linefollow;
                            if (that.horizontaguideLine.attrs.Linefollow) {
                                that.horizontaguideLine.stroke("#4d88ff");
                            } else {
                                that.horizontaguideLine.stroke("#4affff");
                            }
                        }
                        that.horizontaguideLine.attrs.ismove = false;
                    } else if (that.isvertical && that.verticalguideLine) {
                        if (!that.verticalguideLine.attrs.ismove) {
                            that.verticalguideLine.attrs.Linefollow = !that.verticalguideLine.attrs.Linefollow;
                            if (that.verticalguideLine.attrs.Linefollow) {
                                that.verticalguideLine.stroke("#4d88ff");
                            } else {
                                that.verticalguideLine.stroke("#4affff");
                            }
                        }
                        that.verticalguideLine.attrs.ismove = false;
                    }

                    that.isvertical = false;
                    that.ishorizontal = false;
                });
            }
        },
        stageons(width,height) {
            var that = this;
            this.pageStage.on('mousemove', function (e) {

                var endX = e.evt.offsetX;
                var endY = e.evt.offsetY;

                if (that.ishorizontal && that.horizontaguideLine) {
                    that.horizontaguideLine.attrs.ismove = true;
                    that.horizontaguideLine.points([0, endY, width, endY]);
                } else if (that.isvertical && that.verticalguideLine) {
                    that.verticalguideLine.attrs.ismove = true;
                    that.verticalguideLine.points([endX, 0, endX, height]);
                }

                that.pageLayer[4].gridLayer.batchDraw();
            });

            this.pageStage.on('mouseup', function () {
                if (that.ishorizontal && that.horizontaguideLine) {
                    if (!that.horizontaguideLine.attrs.ismove) {
                        that.horizontaguideLine.attrs.Linefollow = !that.horizontaguideLine.attrs.Linefollow;
                        if (that.horizontaguideLine.attrs.Linefollow) {
                            that.horizontaguideLine.stroke("#4d88ff");
                        } else {
                            that.horizontaguideLine.stroke("#4affff");
                        }
                    }
                    that.horizontaguideLine.attrs.ismove = false;
                } else if (that.isvertical && that.verticalguideLine) {
                    if (!that.verticalguideLine.attrs.ismove) {
                        that.verticalguideLine.attrs.Linefollow = !that.verticalguideLine.attrs.Linefollow;
                        if (that.verticalguideLine.attrs.Linefollow) {
                            that.verticalguideLine.stroke("#4d88ff");
                        } else {
                            that.verticalguideLine.stroke("#4affff");
                        }
                    }
                    that.verticalguideLine.attrs.ismove = false;
                }

                that.isvertical = false;
                that.ishorizontal = false;
            });
        },
        
        clearDraw() {
            console.log('触发完成')
        }
    }
}